import React, { useState } from "react";
import headerBg from "./assets/picOne.png";

const StandardsUnderPublicReview = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedStandard, setSelectedStandard] = useState(null);
  const [comment, setComment] = useState("");
  const [isComment, setIsComment] = useState(false);
  const [sectorFilter, setSectorFilter] = useState("");
  const [searchFilter, setSearchFilter] = useState("");

  const standards = [
    {
      number: "DMS 627-2:2025",
      title: "Fibre-cement flat sheets – Product specification and test methods",
      sector: "Civil Engineering",
      tc: 9,
      startDate: "23-10-2025",
      endDate: "23-12-2025",
      status: "Open",
      description:
        "This draft standard specifies requirements and testing methods for fibre-cement flat sheets used in building construction. It includes performance criteria such as strength, durability, dimensional tolerance, and moisture resistance.",
    },
    // add more standards if needed
  ];

  const filteredStandards = standards.filter(
    (std) =>
      (sectorFilter === "" || std.sector === sectorFilter) &&
      (searchFilter === "" || std.title.toLowerCase().includes(searchFilter.toLowerCase()))
  );

  const openPopup = (standard, commentMode = false) => {
    setSelectedStandard(standard);
    setShowPopup(true);
    setIsComment(commentMode); // true if submit comments, false if just viewing
  };

  const closePopup = () => {
    setShowPopup(false);
    setSelectedStandard(null);
    setComment("");
    setIsComment(false);
  };

  const handleSubmitComment = async () => {
    if (!comment.trim()) {
      alert("Please enter your comment.");
      return;
    }

    try {
      const response = await fetch("http://192.168.0.5:7006/api/save-public-comment", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          standardNumber: selectedStandard.number,
          standardTitle: selectedStandard.title,
          comment: comment,
          user: "John Doe", // replace with actual user info
          date: new Date().toISOString(),
        }),
      });
      const data = await response.json();
      if (data.success) {
        alert("Comment submitted successfully!");
        closePopup();
      } else {
        alert("Failed to save comment.");
      }
    } catch (error) {
      console.error(error);
      alert("Error submitting comment. Make sure the backend allows CORS.");
    }
  };

  return (
    <div className="about-us">
      {/* Header */}
      <section className="about-header">
        <div className="overlay">
          <h1 className="page-title">Standards Under Public Review</h1>
          <p className="subtitle">
            Review and provide feedback on public draft standards prepared by the Malawi Bureau of Standards.
          </p>
        </div>
      </section>

      {/* Filters and table */}
      <section className="content-section">
        <div className="table-filters">
          <label>
            Filter By Sector:
            <select onChange={(e) => setSectorFilter(e.target.value)}>
              <option value="">All</option>
              {[...new Set(standards.map((s) => s.sector))].map((sector, i) => (
                <option key={i} value={sector}>{sector}</option>
              ))}
            </select>
          </label>
          <label>
            Search:
            <input
              type="text"
              placeholder="Search..."
              value={searchFilter}
              onChange={(e) => setSearchFilter(e.target.value)}
            />
          </label>
        </div>

        <table className="standards-table">
          <thead>
            <tr>
              <th>Number of draft standard</th>
              <th>Title of draft standard</th>
              <th>Sector</th>
              <th>TC</th>
              <th>Start date</th>
              <th>End date</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredStandards.length === 0 ? (
              <tr>
                <td colSpan="8">No data available</td>
              </tr>
            ) : (
              filteredStandards.map((std, index) => (
                <tr key={index}>
                  <td>{std.number}</td>
                  <td>
                    <span
                      className="link-btn"
                      style={{ color: "red" }}
                      onClick={() => openPopup(std, false)} // view only
                    >
                      {std.title}
                    </span>
                  </td>
                  <td>{std.sector}</td>
                  <td>{std.tc}</td>
                  <td>{std.startDate}</td>
                  <td>{std.endDate}</td>
                  <td>{std.status}</td>
                  <td>
                    <span
                      className="submit-link"
                      onClick={() => openPopup(std, true)} // submit comment
                    >
                      Submit comments
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </section>

      {/* Popup */}
      {showPopup && selectedStandard && (
        <div className="popup-overlay">
          <div className="popup">
            <button className="close-x" onClick={closePopup}>×</button>
            <h2>{selectedStandard.title}</h2>
            <p>{selectedStandard.description}</p>

            {isComment && (
              <>
                <textarea
                  placeholder="Enter your comments here..."
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                />
                <div className="popup-actions">
                  <button onClick={handleSubmitComment}>Submit Comment</button>
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Styles */}
      <style>{`
        .about-us { font-family: Arial, sans-serif; color: #333; }
        .about-header {
          background-image: url(${headerBg});
          background-size: cover;
          background-position: center;
          height: 40vh;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
        }
        .overlay {
          background: rgba(0,0,0,0.55);
          padding: 40px;
          text-align: center;
          color: white;
          width: 90%;
          max-width: 1200px;
          border-radius: 8px;
        }
        .page-title { font-size: 2.4rem; font-weight: bold; }
        .subtitle { margin-top: 10px; font-size: 1rem; }

        .content-section { padding: 40px; text-align: left; }
        .table-filters { display: flex; gap: 20px; margin-bottom: 15px; flex-wrap: wrap; }
        .table-filters label { font-size: 0.95rem; }
        .table-filters select, .table-filters input { margin-left: 6px; padding: 4px 6px; }

        .standards-table { width: 100%; border-collapse: collapse; font-size: 0.95rem; }
        .standards-table th, .standards-table td { border: 1px solid #ddd; padding: 10px 12px; text-align: left; }
        .standards-table th { background-color: #f4f4f4; font-weight: bold; }
        .link-btn { color: #0073e6; cursor: pointer; text-decoration: none; }
        .submit-link { color: red; cursor: pointer; text-decoration: underline; }

        .popup-overlay {
          position: fixed; top: 0; left: 0; right: 0; bottom: 0;
          background: rgba(0,0,0,0.6); display: flex; justify-content: center; align-items: center;
          z-index: 1000;
        }
        .popup { background: #fff; padding: 25px; width: 500px; max-width: 95%; border-radius: 8px; position: relative; }
        .close-x { position: absolute; top: 10px; right: 12px; font-size: 1.6rem; background: none; border: none; cursor: pointer; }
        .popup textarea { width: 100%; height: 100px; margin-top: 10px; padding: 8px; border-radius: 5px; border: 1px solid #ccc; resize: none; }
        .popup-actions { display: flex; justify-content: flex-end; margin-top: 10px; }
        .popup-actions button { padding: 8px 12px; border: none; border-radius: 4px; background-color: #0073e6; color: white; cursor: pointer; }
      `}</style>
    </div>
  );
};

export default StandardsUnderPublicReview;
